function convertTripType(type) {
    return {
        roundTrip: 'ROUND_TRIP',
        oneWayTrip: 'ONE_WAY',
        multipleTrip: 'MULTIPLE_DESTINATIONS',
    }[type];
}

function convertUrl(params) {
    const {protocol, host} = window.location;
    return `${protocol}//${host}/travel/#results/${params}`;
}

function convert(data, params) {
    return {
        itinerarySearchRequest: {
            type: convertTripType(data.type),
            numAdults: data.numAdults,
            numChildren: data.numChildren,
            numInfants: data.numInfants,
            cabinClass: data.cabinClass,
            mainAirportsOnly: false,
            directFlightsOnly: data.directFlightsOnly,
            searchMainProductType: 'FLIGHT',
            airlinesCodes: data.airlinesCodes,
            externalSelectionRequest: {},
            dynpackSearch: false,
            segmentRequests: data.searchSegments.map((segment) => ({
                dateStr: segment.dateStr,
                date: segment.dateStr,
                departure: {
                    iata: segment.departure.iata,
                    name: segment.departure.name,
                    geoNodeId: segment.departure.geoNodeId,
                    type: segment.departure.type,
                },
                destination: {
                    iata: segment.destination.iata,
                    name: segment.destination.name,
                    geoNodeId: segment.destination.geoNodeId,
                    type: segment.destination.type,
                },
                time: '0000',
            })),
            urlSearch: convertUrl(params),
        },
        buyPath: data.buyPath,
    };
}

// TODO: once we remove the old FlightsManager, this function can be moved to a react utils
module.exports = function(data, params) {
    var url = '/travel/service/flow/search';

    if ('serviceWorker' in navigator && null !== navigator.serviceWorker.controller) {
        fetch(url, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(convert(data, params)),
        });
    }
};
